import { AppService, ResponseStatus, UsuarioService } from "../rest"
import Storage from "./storage"
import Toast from "./toast"
import Validator from "./validator"

const Data = {
    listNames: {
        estados: "estados",
        categorias: "categorias",
        unidades_medida: "unidades_medida",
        marcas: "marcas",
        almacenes: "almacenes",
        condiciones_comerciales: "condiciones_comerciales",
        tipos_producto: "tipos_producto",
    },
    modulos: {
        pedidoItems: "pedido_items",
        transferenciasItems: "transferencias_items",
        asignacionesItems: "asignaciones_items",
    },
    tipoTransferencia: {
        ordenCompra: {
            tid_id: 1,
            tid_nombre: "Orden de Compra",
        },
        entreAlmacenes: {
            tit_id: 2,
            tid_nombre: "Entre Almacenes",
        },
        compraExterna: {
            tid_id: 3,
            tid_nombre: "Compra Externa",
        }
    },
    loadLists: () => {
        const request = ["estados", "categorias", "marcas", "unidades_medida", "almacenes", "condiciones_comerciales", "tipos_producto"]
        AppService
            .getData(request)
            .then(response => {
                if (ResponseStatus.isSuccess(response)) {
                    Storage.setObject(Data.listNames.estados, response.data.estados)
                    Storage.setObject(Data.listNames.categorias, response.data.categorias)
                    Storage.setObject(Data.listNames.unidades_medida, response.data.unidades_medida)
                    Storage.setObject(Data.listNames.marcas, response.data.marcas)
                    Storage.setObject(Data.listNames.almacenes, response.data.almacenes)
                    Storage.setObject(Data.listNames.condiciones_comerciales, response.data.condiciones_comerciales)
                    Storage.setObject(Data.listNames.tipos_producto, response.data.tipos_producto)
                }
                else {
                    Toast.warn(response.message)
                }
            })
            .catch(error => {
                Toast.error(error)
                
            })
    },
    getAlmacenes: () => {
        const usuario = UsuarioService.getUsuario()
        if (usuario.usu_nivel == 1) {
            return Data.get(Data.listNames.almacenes)
        }
        else {
            if (Validator.start(usuario.pry_id)) {
                return Data.get(Data.listNames.almacenes).filter(item => item.pry_id == usuario.pry_id)
            }
            else {
                Toast.warn("No te encuentras asignado a ningun proyecto, no te puedo mostrar almacenes")
                return []
            }
        }
    },
    getEstados: (modulo) => {
        let estados = []
        switch (modulo) {
            case Data.modulos.transferenciasItems:
                estados = Data.get(Data.listNames.estados).filter(item =>
                    item.est_codigo == "creado"
                    || item.est_codigo == "eliminado"
                    || item.est_codigo == "ingreso_confirmado"
                    || item.est_codigo == "ingreso_parcial"
                )
                break
            case Data.modulos.asignacionesItems:
                estados = Data.get(Data.listNames.estados).filter(item =>
                    item.est_codigo == "creado"
                    || item.est_codigo == "asignado"
                    || item.est_codigo == "eliminado"
                )
                break
            case Data.modulos.pedidoItems:
                estados = Data.get(Data.listNames.estados).filter(item =>
                    item.est_codigo == "creado"
                    || item.est_codigo == "aprobado"
                    || item.est_codigo == "eliminado"
                )
                break
        }
        return estados
    },
    getTiposTransferencia: () => {
        return [
            Data.tipoTransferencia.ordenCompra,
            Data.tipoTransferencia.compraExterna,
            Data.tipoTransferencia.entreAlmacenes,
        ]
    },
    getTipoAsignacion: () => {
        return [
            {
                tip_id: 1,
                tip_nombre: "Asignaciones"
            },
            {
                tip_id: 2,
                tip_nombre: "Devoluciones"
            },
        ]
    },

    get: (name) => {
        return Storage.getObject(name)
    }
}

export default Data